var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComment({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "comment-svg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    className: "svg comment",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "comment") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5,32V25.4H4.6A3.9,3.9,0,0,1,.7,21.5V3.9A4,4,0,0,1,4.6,0H28a4,4,0,0,1,4,3.9V21.5a3.9,3.9,0,0,1-3.9,3.9H19.3ZM4.6,2.5A1.37,1.37,0,0,0,3.2,3.9V21.5a1.37,1.37,0,0,0,1.4,1.4H13V27l5.5-4.1h9.6a1.37,1.37,0,0,0,1.4-1.4V3.9a1.37,1.37,0,0,0-1.4-1.4Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/comment.dbbfaf8f5633e11201635d16bdc96994.svg";
export { ForwardRef as ReactComponent };